export enum ONBOARDING_FLOW {
  PastClients = 'PAST_CLIENTS',
  Retention = 'RETENTION',
  TransactionMgmt = 'TRANSACTION_MGMT',
  PropertySearch = 'PROPERTY_SEARCH',
  NotSure = 'NOT_SURE',
}
